//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { UniversalPostType } from '@apis/universal-posts/universalPostsApiModel';
import { IFacebookFormState } from '@universal-scheduling/models/SchedulerPostDetailsModels';

export const DEFAULT_FACEBOOK_POST_DETAILS_FORM_STATE: IFacebookFormState = {
  postType: UniversalPostType.FacebookPageFeedPost,
  link: '',
  postBodyLinkIds: [],
  caption: '',
  postNow: false,
};

export const FACEBOOK_PAGE_SEARCH_COUNT = 20;
export const FACEBOOK_VERIFIED_PAGE_STATUS = 'blue_verified';

export const FacebookPostDetailsFormFieldErrorText = {
  NoMediaOrLink: 'Please add either media or a link to this post.',
} as const;
